import '../../common/theme.mjs';
import '../../common/direction.mjs';
import '../../common/propsValues/control.mjs';
import '../../common/propsValues/breakpoint.mjs';
import '../../common/propsValues/size.mjs';
import '../../common/propsValues/typography.mjs';
import '../../common/propsValues/width.mjs';
import '../../common/propsValues/type.mjs';
import '../../common/propsValues/dateMode.mjs';
import '../../common/propsValues/monthFormat.mjs';
import '../../common/propsValues/position.mjs';
import '../../common/propsValues/layouts.mjs';
import '../../common/propsValues/status.mjs';
import '../../common/propsValues/sentiment.mjs';
import '../../common/propsValues/profileType.mjs';
import '../../common/propsValues/variant.mjs';
import '../../common/propsValues/scroll.mjs';
import { MarkdownNodeType } from '../../common/propsValues/markdownNodeType.mjs';
import '../../common/fileType.mjs';
import '@transferwise/icons';
import 'clsx';
import 'react';
import 'react-intl';
import '../../common/closeButton/CloseButton.messages.mjs';
import { jsx } from 'react/jsx-runtime';
import Markdown from '../../markdown/Markdown.mjs';

const allowList = [MarkdownNodeType.STRONG];
function InlineMarkdown(props) {
  return /*#__PURE__*/jsx(Markdown, {
    ...props,
    as: "span",
    allowList: allowList,
    blockList: undefined
  });
}

export { InlineMarkdown as default };
//# sourceMappingURL=InlineMarkdown.mjs.map
